/*
 * variant-refresh.js - Clix Media
 * Ververst variantafhankelijke blokken (SKU/EAN, specificaties, ...) na een variantwissel.
 * Markeer een blok in Liquid met een unieke id + data-variant-refresh, bv:
 *   <div id="product-meta-{{ section.id }}" data-variant-refresh>...</div>
 */
(function () {
  if (window.__variantRefreshInit) return;
  window.__variantRefreshInit = true;

  var controllers = {};

  document.addEventListener('product:variant-change', function (event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    var sectionId = detail.sectionId;
    if (!variant || !sectionId) return;

    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var targets = section.querySelectorAll('[data-variant-refresh][id]');
    if (!targets.length) return;

    var selects = section.querySelector('variant-selects, variant-radios');
    var baseUrl = (selects && selects.dataset.url) || window.location.pathname;

    if (controllers[sectionId]) controllers[sectionId].abort();
    var controller = new AbortController();
    controllers[sectionId] = controller;

    var url = baseUrl + '?variant=' + encodeURIComponent(variant.id) + '&section_id=' + encodeURIComponent(sectionId);

    fetch(url, { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        targets.forEach(function (target) {
          var source = doc.getElementById(target.id);
          if (source) target.innerHTML = source.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('product:variant-refreshed', {
          detail: { variant: variant, sectionId: sectionId }
        }));
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') console.warn('[variant-refresh]', error);
      });
  });
})();
